<template>
  <div :class="campaignClass" :style="campaignBg">
    <div class="inner-content" v-if="campaign.title.rendered">
      <div class="campaign-header" :class="headerClass">
        <div class="wrap">
          <router-link :to="childUrl('')" tag="a">
            <img :src="campaign.icon" class="icon">
            <h1 v-html="campaign.title.rendered"></h1>
          </router-link>
        </div>
      </div>

      <ul class="campaign-menu" v-if="this.$route.name === 'nc-campaign'">
        <router-link :to="childUrl('покана')" tag="li"><a>Покана</a></router-link>
        <router-link :to="childUrl('дневен-ред')" tag="li"><a>Дневен ред</a></router-link>
        <router-link :to="childUrl('предложения')" tag="li"><a>Предложения</a></router-link>
        <router-link :to="childUrl('гласуване')" tag="li"><a>Гласуване</a></router-link>
      </ul>

      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NCCampaignDetail',

  asyncData ({ store, route }) {
    return store.dispatch('getNCCampaign', route.params.slug)
  },

  mounted () {
    if (typeof this.$store.getters.nationalCouncilCatId === 'undefined') {
      this.$store.dispatch('getNationalCouncilCategoryId').then(() => {
        this.$store.dispatch('getNCCampaign', this.$route.params.slug)
      })
    } else {
      this.$store.dispatch('getNCCampaign', this.$route.params.slug)
    }
  },

  methods: {
    childUrl (slug) {
      return '/национален-съвет/' + this.campaign.slug + '/' + slug
    }
  },

  computed: {
    campaign () {
      return this.$store.getters.ncCampaign
    },

    campaignClass () {
      return this.$route.name === 'nc-campaign' ? 'campaign' : 'campaign ' + this.$route.name
    },

    campaignBg () {
      if (this.$route.name === 'nc-campaign') {
        let bg = this.$store.getters.campaignBg
        return bg !== false ? { 'background-image': 'url(' + bg + ')' } : false
      } else {
        return {}
      }
    },

    headerClass () {
      return this.$route.name === 'nc-campaign' ? 'header-full' : 'header-collapsed'
    }
  }
}
</script>
